//css import
import '../../scss/pages/songs.scss';
import { pageHeader } from '../sections/page-header.js';

const songPartnerUsTitle=document.querySelector('#song-partner-us-title');
const titleHolderMobile=document.querySelector('.song-partner-us__title-mobile');
const titleHolderDesktop=document.querySelector('.song-partner-us__title-desktop');

document.addEventListener("DOMContentLoaded", function () { 
    pageHeader();
    if (window.innerWidth <= 767) {
        titleHolderMobile.append(songPartnerUsTitle)
	} else {
		titleHolderDesktop.append(songPartnerUsTitle)
	}
});

window.addEventListener("resize", function(){
    if (window.innerWidth <= 767) {
        titleHolderMobile.append(songPartnerUsTitle)
	} else {
		titleHolderDesktop.append(songPartnerUsTitle)
	}
});
